<template>
  <div>
    <Panel :data="request"/>
    <hr>

    <h3>Histórico de Multas</h3>
    <TicketHistories v-if="request && request.id" :request="request"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Panel from '../Panel.vue'
import TicketHistories from './TicketHistories'
import { mapMutations } from 'vuex'

export default {
  components: { Panel, TicketHistories },
  computed: {
    request() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'Request',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>